import { render } from "./KlaviyoForm.vue?vue&type=template&id=de422594&scoped=true"
import script from "./KlaviyoForm.vue?vue&type=script&lang=js"
export * from "./KlaviyoForm.vue?vue&type=script&lang=js"

import "./KlaviyoForm.vue?vue&type=style&index=0&id=de422594&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de422594"]])

export default __exports__